module.exports = __webpack_public_path__ + "static/media/ProjectActive.4945199e.png";